<template>
    <div class="text-input"
        :class="{
            'has-focus': hasFocus,
            'has-value': hasValue,
        }">
        <label
            class="text-input__label"
            :for="id"
        >{{ labelText }}</label>
        <input
            v-if="tag === 'input'"
            ref="field"
            class="text-input__field"
            type="text"
            :name="name"
            :id="id"
            :value="value"
            :readonly="readonly"
            :disabled="disabled"
            :valid="false"
            @focus="onFocus"
            @blur="onBlur"
            @input="onInput"
            @paste="onPaste"
            @change="onChange"
            :data-mask="mask"
            :inputmode="$attrs.inputmode"
            :autocomplete="autocomplete"
            @keypress.enter="onEnterPress"
        >
        <textarea
            v-if="tag === 'textarea'"
            ref="field"
            :class="`text-input__field text-input__field--${tag}`"
            :name="name"
            :id="id"
            :value="value"
            :readonly="readonly"
            :disabled="disabled"
            @focus="onFocus"
            @blur="onBlur"
            @input="onInput"
            @paste="onPaste"
            @change="onChange"
            :data-mask="mask"
        ></textarea>
        <button
            class="text-input__clear"
            type="button"
            tabindex="-1"
            v-if="clearable && hasValue && !readonly && !disabled"
            @click="clear"
        >
            <svg><use xlink:href="/sprite.svg#icon-close"></use></svg>
        </button>
        <div
            class="text-input__status" :data-error="statusError"
            v-if="statusText"
        >
            {{ statusText }}
        </div>
    </div>
</template>

<script>
import { initMaskFields } from '../../../modules/mask';

export default {
    name: 'text-input',

    props: {
        id: {
            required: false,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
        type: {
            required: false,
            type: String,
            default: 'text',
        },
        value: {
            required: false,
            type: String || Boolean,
        },
        status: {
            required: false,
            type: String,
        },
        mask: {
            required: false,
            type: String,
        },
        readonly: {
            required: false,
            type: Boolean,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        placeholder: {
            required: false,
            type: String,
        },
        clearable: {
            required: false,
            type: Boolean,
            default: true,
        },
        tag: {
            required: false,
            type: String,
            default: 'input',
        },
        hint: {
            required: false,
            type: String,
        },
        autosize: {
            default: false,
        },
        autocomplete: {
            type: String,
            default: 'off',
        },
        valid: {
            default: false,
            type: Boolean,
        },
    },

    data() {
        return {
            hasFocus: false,
        };
    },

    computed: {
        statusError(){
            let status = this.status ? this.status.replace('Поле', 'Поле '+ this.labelText) : '';
            let hint = this.hint ? this.hint.replace('Поле', 'Поле '+ this.labelText) : '';
            return this.valid ? "" : (status || hint);
        },
        hasValue() {
            return !!this.value;
        },
        labelText() {
            return this.placeholder && !this.hasValue ? this.placeholder : this.label;
        },
        statusText() {
            return this.status || this.hint;
        },
    },

    mounted() {
        this.$nextTick(() => {
            initMaskFields();
        });
    },

    methods: {
        focus() {
            try {
                this.$refs.field.focus();
            } catch (error) {
                console.error(error.message);
            }
        },

        onFocus() {
            if (this.readonly) return;
            this.hasFocus = true;
        },

        onBlur() {
            this.hasFocus = false;
        },

        onInput(e) {
            const { target } = e;

            this.$emit('input', target.value);
            if (this.tag === 'textarea' && this.autosize) {
                target.style.cssText = '';
                target.style.cssText = `height: ${target.scrollHeight + 2}px;`;
            }
        },

        onPaste() {
            setTimeout(() => {
                this.$emit('input', this.$refs.field.value);
            }, 0);
        },

        onChange(e) {
            this.$emit('input', e.target.value);
        },

        onEnterPress() {
            this.$emit('enter-press', this.$refs.field.value);
        },

        clear() {
            this.$emit('input', '');
            this.$refs.field.style.cssText = '';
        },
    },
};
</script>
